import { render, staticRenderFns } from "./Wap.vue?vue&type=template&id=1f36c1db&scoped=true&"
import script from "./Wap.vue?vue&type=script&lang=js&"
export * from "./Wap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f36c1db",
  null
  
)

export default component.exports